import React, { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const LabsImagingRecords = ({
  patientDBdata,
  diagnosisName,
  setPatientDBdata,
  noteID,
  isHavingLabImaging,
  setIsHavingLabImaging
}) => {
  const [tempHtml, setTempHtml] = useState('')
  const [originalHtml, setOriginalHtml] = useState('')
  // const [isHavingLabImaging, setIsHavingLabImaging] = useState(false)

  useEffect(() => {
    if (!diagnosisName) return

    const savedHtml =
      patientDBdata?.currentNote?.data?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging

    const rawText =
      patientDBdata?.currentNote?.data?.assessment?.[diagnosisName]?.LabImaging || ''

    const generatedHtml = `
      <div>
        <div style="white-space:pre-line;">
          ${rawText || '—'}
        </div>
      </div>
    `

    setIsHavingLabImaging(Boolean(rawText.length))

    const initialHtml = savedHtml || generatedHtml

    setOriginalHtml(generatedHtml)
    setTempHtml(initialHtml)

    if (!savedHtml) {
      setPatientDBdata((prev) => ({
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev.currentNote.data,
            freeTypesEverything: {
              ...prev.currentNote.data?.freeTypesEverything,
              assessments: {
                ...(prev.currentNote.data?.freeTypesEverything?.assessments || {}),
                [diagnosisName]: {
                  ...prev.currentNote.data?.freeTypesEverything?.assessments?.[diagnosisName],
                  LabImaging: generatedHtml,
                },
              },
            },
          },
        },
      }))
    }
  }, [diagnosisName])

  const handleBlur = () => {
    if (!tempHtml.trim()) return

    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            assessments: {
              ...(prev.currentNote.data?.freeTypesEverything?.assessments || {}),
              [diagnosisName]: {
                ...prev.currentNote.data?.freeTypesEverything?.assessments?.[diagnosisName],
                LabImaging: tempHtml,
              },
            },
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteID) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
              assessments: {
                ...(parsedData.freeTypesEverything?.assessments || {}),
                [diagnosisName]: {
                  ...parsedData.freeTypesEverything?.assessments?.[diagnosisName],
                  LabImaging: tempHtml,
                },
              },
            },
          }),
        }
      }),
    }))
  }

  if (!isHavingLabImaging) return null

  return (
    <div className="w-100 my-4">
      <div style={{ width: '30%' }}>Lab Imaging</div>
      <Editor
        value={tempHtml}
        onChange={(e) => setTempHtml(e.target.value)}
        onBlur={handleBlur}
        containerProps={{
          style: {
            width: '100%',
            background: '#2D2D2D',
            color: 'white',
            border: 0,
          },
        }}
      >
        <Toolbar hidden />
      </Editor>
    </div>
  )
}

export default LabsImagingRecords


